import { DefaultDialCodeOption } from '@/components/shared/components/NewContextForms/PhoneFormDoubleField/constants/DefaultDialCodeOption';

export const DefaultDistributionForm = {
  activeMethods: {
    email: true,
    sms: false,
  },
  email: '',
  dialCode: DefaultDialCodeOption,
  phoneNumber: '',
};
